import { FC } from 'react';

import { Stack, Typography } from '@mui/material';

import { NavGroupType } from '@src/types/main';

import NavItem from '../nav-item';
import NavSubGroup from '../nav-sub-group';

type NavGroupProps = {
  group: NavGroupType;
};

const NavGroup: FC<NavGroupProps> = (props) => {
  const { group } = props;

  return (
    <Stack>
      <Typography variant="subtitle2" sx={{ pl: 5, pb: 2 }}>
        {group.label}
      </Typography>
      <Stack>
        {group.entries.map((entry) =>
          entry.type === 'subGroup' ? (
            <NavSubGroup key={entry.id} group={entry} />
          ) : (
            <NavItem key={entry.id} item={entry} />
          )
        )}
      </Stack>
    </Stack>
  );
};

export default NavGroup;
